import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class PredictionDetailsPopup extends AssetsRequestParams {
  constructor(width: Number,height: Number) {
    super(width, height)

    this.resourceName = `${this.resourceName}/Popup_Icon`;
  }
}